import { put, takeLatest } from 'redux-saga/effects';
import handleException from './../services/handleException';
import { saveChannel, verifyChannel } from './../utils/settingChannel';

function* verifyChannelHandle(data) {
    try {
        const json = yield verifyChannel(data.payload)
        if (json.data.code == 10001)
            yield put({
                type: 'VERIFY_SUCCESS',
                json: json.result
            })
        else {
            handleException(json)
            yield put({
                type: 'ERROR_ECCHANNELS'
            })
        }
    } catch (error) {
        handleException(error)
        yield put({
            type: 'VERIFY_FAILURE',
            error
        })
    }
}

function* saveChannelHandle(data) {
    try {
        const json = yield saveChannel(data.payload)

        if (json.data.code == 10001)
            yield put({
                type: 'SAVE_CHANNEL_SUCCESS',
                json: json
            })
        else {
            handleException(json)
            yield put({
                type: 'ERROR_ECCHANNELS'
            })
        }
    } catch (error) {
        handleException(error)
        yield put({
            type: 'SAVE_CHANNEL_FAILURE',
            error
        })
    }
}

export function* settingChannelSaga() {
    yield takeLatest('ON_VERIFY', verifyChannelHandle)
}

export function* saveChannelSaga() {
    yield takeLatest('ON_SAVE_CHANNEL', saveChannelHandle)
}


// WEBPACK FOOTER //
// ./src/sagas/settingChannelSaga.js